"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Tabs extends _react.Component {
  static defaultProps = {
    selectedIndex: 0
  };
  state = {
    selectedIndex: this.props.selectedIndex
  };
  constructor(props) {
    super(props);
    const {
      numTabs,
      numPanels
    } = this._getNumItems();
    if (numTabs !== numPanels) {
      throw new Error('The number of Tab components must correspond to the number of TabPanel components provided.');
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      onSelect
    } = this.props;
    const {
      selectedIndex
    } = this.state;
    if (prevState.selectedIndex !== selectedIndex && onSelect) {
      onSelect(selectedIndex);
    }
  }
  _getNumItems() {
    const {
      children
    } = this.props;
    return {
      numTabs: _react.Children.count(children[0].props.children),
      numPanels: _react.Children.count(children[1].props.children)
    };
  }
  _selectTab = index => {
    this.setState({
      selectedIndex: index
    });
  };
  _renderNavigation(nav) {
    return /*#__PURE__*/(0, _react.cloneElement)(nav, {
      selectedIndex: this.state.selectedIndex,
      onTabClick: this._selectTab
    });
  }
  _renderContent(content) {
    return /*#__PURE__*/(0, _react.cloneElement)(content, {
      selectedIndex: this.state.selectedIndex
    });
  }
  render() {
    const {
      className,
      children
    } = this.props;
    const classes = (0, _classnames.default)('Tabs', className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, this._renderNavigation(children[0]), this._renderContent(children[1]));
  }
}
exports.default = Tabs;